/**
 * Lista de 02/11 (item 1): campos personalizados (chave) que o CRM não mostra nos formulários nem na ficha, porque têm campo próprio
 * (o WhatsApp virou tipo de telefone). O valor guardado em `extras` não se perde: segue indo inteiro na gravação.
 *
 * Mora no núcleo (rl0211-1 SPEC-B1): Cadastros e Pipeline usam a mesma lista, e tela de módulo não importa tela de outro módulo.
 */
export const EXTRAS_FORA_DO_CRM = ['whatsapp'];
